import {
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { UserName, UserNameDTO } from "../types/userName";
/* eslint-disable import/export */
export abstract class UpdateUsernameRPC implements
  LeoRPC<UpdateUsernameRPC.Request, UpdateUsernameRPC.Response, UpdateUsernameRPC.Errors.Errors>
{
  abstract execute(
    request: UpdateUsernameRPC.Request
  ): Promise<LeoRPCResult<UpdateUsernameRPC.Response, UpdateUsernameRPC.Errors.Errors>>;
}

export namespace UpdateUsernameRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    userName: UserNameDTO;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isUpdateUsernameRPCRequest: boolean = true;
  
    readonly userName: UserName;
  
  
    constructor(
    userName: UserName
    ) {
      this.userName = userName;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const userName = UserName.fromDTO(getObject(dto, "userName", InvalidRequestUserNameError));
      return new Request(
        userName
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          userName: this.userName.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `UpdateUsernameRPC(userName='${this.userName}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `UpdateUsernameRPC.Response()`;
  };

  export enum RPCError {
    UnableToUpdateUsername = "UNABLE_TO_UPDATE_USERNAME"
  }

  export namespace Errors {
    
    export interface UnableToUpdateUsernameDTO {
      code: string;
    }
    
    export class UnableToUpdateUsername extends LeoRPCError<RPCError> {
      readonly isUnableToUpdateUsername: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.UnableToUpdateUsername;
        super(code);
      }
    
    
      toDTO(): UnableToUpdateUsernameDTO {
        const dto: UnableToUpdateUsernameDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    UnableToUpdateUsername.prototype.toString = function toString(): string {
      return `UpdateUsernameRPC.UNABLE_TO_UPDATE_USERNAME()`;
    };
    

    export type Errors = UnableToUpdateUsername;
    export type ErrorsDTO = UnableToUpdateUsernameDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.UnableToUpdateUsername:
          return new UnableToUpdateUsername();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestUserNameError extends UpdateUsernameRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestUserNameError";
  }
}


export class InvalidResponseUnableToUpdateUsernameError extends UpdateUsernameRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseUnableToUpdateUsernameError";
  }
}

